import { LIFESTYLE } from './constants/progressCategories';
import consultationSigninSignin from './questions/consultationSigninSignin';
import consultationWelcome from './questions/consultationWelcome';
import myGoalsGoals from './questions/myGoalsGoals';
import myHairAge from './questions/myHairAge';
import myHairDandruffLevel from './questions/myHairDandruffLevel';
import myHairDensity from './questions/myHairDensity';
import myHairGeneticHairLoss from './questions/myHairGeneticHairLoss';
import myHairGray from './questions/myHairGray';
import myHairHairloss from './questions/myHairHairloss';
import myHairLength from './questions/myHairLength';
import myHairOil from './questions/myHairOil';
import myHairPorosity from './questions/myHairPorosity';
import myHairSensitivity from './questions/myHairSensitivity';
import myHairShampooFrequency from './questions/myHairShampooFrequency';
import myHairSplitEnds from './questions/myHairSplitEnds';
import myHairTexture from './questions/myHairTexture';
import myHairThickness from './questions/myHairThickness';
import myHairType from './questions/myHairType';
import myLifestyleDiet from './questions/myLifestyleDiet';
import myLifestyleGeoAggressors from './questions/myLifestyleGeoAggressors';
import myLifestyleHormones from './questions/myLifestyleHormones';
import myLifestyleHydration from './questions/myLifestyleHydration';
import myLifestyleOtherHairLossCauses from './questions/myLifestyleOtherHairLossCauses';
import myLifestyleSmokeExposure from './questions/myLifestyleSmokeExposure';
import myLifestyleSports from './questions/myLifestyleSports';
import myLifestyleStress from './questions/myLifestyleStress';
import myLifestyleTransitionScreen from './questions/myLifestyleTransitionScreen';
import myLifestyleZipcode from './questions/myLifestyleZipcode';
import myPreferencesExceptions from './questions/myPreferencesExceptions';
import myPreferencesFragrance from './questions/myPreferencesFragrance';
import myPreferencesTransitionScreen from './questions/myPreferencesTransitionScreen';
import myTreatmentsColorTreatments from './questions/myTreatmentsColorTreatments';
import myTreatmentsColorTreatmentsCadence from './questions/myTreatmentsColorTreatmentsCadence';
import myTreatmentsColorTreatmentsLocation from './questions/myTreatmentsColorTreatmentsLocation';
import myTreatmentsColorTreatmentsType from './questions/myTreatmentsColorTreatmentsType';
import myTreatmentsExtensionsTypes from './questions/myTreatmentsExtensionsTypes';
import myTreatmentsOtherTreatments from './questions/myTreatmentsOtherTreatments';
import myTreatmentsOtherTreatmentsCadence from './questions/myTreatmentsOtherTreatmentsCadence';
import myTreatmentsRoutine from './questions/myTreatmentsRoutine';
import myTreatmentsStyles from './questions/myTreatmentsStyles';
import myTreatmentsStylesCadence from './questions/myTreatmentsStylesCadence';
import myTreatmentsTransitionScreen from './questions/myTreatmentsTransitionScreen';

export default [
  consultationWelcome,
  // -----------------------------------------------------
  // HAIR AND SCALP
  { ...myHairAge, public: true },
  { ...myHairTexture, public: true },
  { ...myHairLength, public: true },
  { ...myHairType, public: true },
  { ...myHairSplitEnds, public: true },
  { ...myHairPorosity, public: true },
  { ...myHairThickness, public: true },
  { ...myHairDensity, public: true },
  { ...myHairHairloss, public: true },
  { ...myHairGeneticHairLoss, public: true },
  { ...myHairShampooFrequency, public: true },
  { ...myHairOil, public: true },
  { ...myHairDandruffLevel, public: true },
  { ...myHairSensitivity, public: true },
  { ...myHairGray, public: true },
  // -----------------------------------------------------
  // TREATMENT AND STYLING
  { ...myTreatmentsTransitionScreen, public: true },
  { ...myTreatmentsColorTreatments, public: true },
  { ...myTreatmentsColorTreatmentsLocation, public: true },
  { ...myTreatmentsColorTreatmentsType, public: true },
  { ...myTreatmentsColorTreatmentsCadence, public: true },
  { ...myTreatmentsOtherTreatments, public: true },
  { ...myTreatmentsOtherTreatmentsCadence, public: true },
  { ...myTreatmentsStyles, public: true },
  { ...myTreatmentsStylesCadence, public: true },
  { ...myTreatmentsExtensionsTypes, public: true },
  { ...myTreatmentsRoutine, public: true },
  // -----------------------------------------------------
  // LIFESTYLE AND ENVIRONMENT
  { ...myLifestyleTransitionScreen, public: true },
  { ...myLifestyleHormones, public: true },
  { ...myLifestyleDiet, public: true },
  { ...myLifestyleHydration, public: true },
  { ...myLifestyleSmokeExposure, public: true },
  { ...myLifestyleStress, public: true },
  { ...myLifestyleOtherHairLossCauses, public: true },
  { ...myLifestyleSports, public: true },
  {
    ...consultationSigninSignin,
    progressCategory: LIFESTYLE,
    title: "Almost done. Let's save your results to move forward.",
  },
  myLifestyleZipcode,
  myLifestyleGeoAggressors,
  // -----------------------------------------------------
  // PREFERENCES AND FRAGRANCE
  myPreferencesTransitionScreen,
  myPreferencesExceptions,
  myPreferencesFragrance,
  // -----------------------------------------------------
  // HAIR GOALS
  myGoalsGoals,
];
